module.exports = __webpack_public_path__ + "static/media/logo_porfesr.575c3287.png";